//TODO: DONE! create contact using all actions

import {
    SET_CONTACT,
    SET_LOADING,
    CONTACT_TO_UPDATE,
    SET_SINGLE_CONTACT,
} from "./action.types";

//TODO: DONE! use switch case
export default (state, action) => {
    switch (action.type) {
        case SET_CONTACT:
            //payload is obj coming from firebase
            //action acts as an carrier
            return action.payload == null
                ? { ...state, contacts: [] }
                : { ...state, contacts: action.payload };

        case SET_LOADING:
            return { ...state, isLoading: action.payload };

        case CONTACT_TO_UPDATE:
            return {
                ...state,
                contactToUpdate: action.payload,
                contactToUpdateKey: action.key,
            };

        case SET_SINGLE_CONTACT:
            return {
                ...state,
                contact: action.payload,
            };
        default:
            return state;
    }
};
